import * as Constants from '../constants';

export const getPetTransactions = ($http, ENV, petId, orgId) => (dispatch, getState) =>
  new Promise((resolve, reject) => {
    dispatch({ type: Constants.GET_PET_TRANSACTIONS_REQUEST });

    $http({
      method: 'GET',
      url: ENV.apiEndpoint + `/1.0/pets/${petId}/transactions/`,
      params: getState().auth.isAdminUser ? {} : { organization_id: orgId },
    })
      .then((res) => {
        dispatch({
          type: Constants.GET_PET_TRANSACTIONS_SUCCESS,
          payload: res.data.pet.transactions,
        });
        resolve(res.data.pet.transactions);
      })
      .catch((error) => {
        dispatch({ type: Constants.GET_PET_TRANSACTIONS_FAILED, payload: error });
        reject(error);
      });
  });

export const getTransaction = ($http, ENV, transactionId) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: Constants.GET_TRANSACTION_REQUEST });

    $http({
      method: 'GET',
      url: ENV.apiEndpoint + `/2.0/transactions/${transactionId}/`,
    })
      .then((res) => {
        dispatch({
          type: Constants.GET_TRANSACTION_SUCCESS,
          payload: res.data.transaction,
        });
        resolve(res.data.transaction);
      })
      .catch((error) => {
        dispatch({ type: Constants.GET_TRANSACTION_FAILED, payload: error });
        reject(error);
      });
  });

export const updateTransaction = ($http, ENV, transactionId, transactionInfo) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: Constants.UPDATE_TRANSACTION_REQUEST });

    const request = Object.assign(
      {
        method: 'PUT',
        url: ENV.apiEndpoint + `/2.0/transactions/${transactionId}/`,
      },
      transactionInfo && { data: transactionInfo },
    );

    $http(request)
      .then((res) => {
        dispatch({ type: Constants.UPDATE_TRANSACTION_SUCCESS, payload: res.data.transaction });
        resolve(res.data.transaction);
      })
      .catch((error) => {
        dispatch({ type: Constants.UPDATE_TRANSACTION_FAILED, payload: error });
        reject(error);
      });
  });

export const applyCode = ($http, ENV, transactionId, promotionCodeId) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: Constants.APPLY_CODE_REQUEST });

    $http({
      method: 'PUT',
      url:
        ENV.apiEndpoint + `/2.0/transactions/${transactionId}/promotion-codes/${promotionCodeId}/`,
    })
      .then((res) => {
        dispatch({ type: Constants.APPLY_CODE_SUCCESS, payload: res.data.transaction });
        resolve(res.data.transaction);
      })
      .catch((error) => {
        dispatch({ type: Constants.APPLY_CODE_FAILED, payload: error });
        reject(error);
      });
  });

export const reScanForCodes = ($http, ENV, transactionId) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: Constants.RESCAN_FOR_CODES_REQUEST });

    $http({
      method: 'GET',
      url: ENV.apiEndpoint + `/2.0/transactions/${transactionId}/?rescan_for_promotion_codes=true`,
    })
      .then((res) => {
        dispatch({ type: Constants.RESCAN_FOR_CODES_SUCCESS, payload: res.data.transaction });
        resolve(res.data.transaction);
      })
      .catch((error) => {
        dispatch({ type: Constants.RESCAN_FOR_CODES_FAILED, payload: error });
        reject(error);
      });
  });

export const retryCode = ($http, ENV, activityId) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: Constants.RETRY_CODE_REQUEST });

    $http({
      method: 'PUT',
      url: ENV.apiEndpoint + `/1.0/transaction-activities/${activityId}/`,
    })
      .then((res) => {
        dispatch({ type: Constants.RETRY_CODE_SUCCESS, payload: res.data.transaction });
        resolve(res.data.transaction);
      })
      .catch((error) => {
        dispatch({ type: Constants.RETRY_CODE_FAILED, payload: error });
        reject(error);
      });
  });

export const getDenialReason = ($http, ENV) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: Constants.GET_DENIAL_REASON_REQUEST });

    $http({
      method: 'GET',
      url: ENV.apiEndpoint + `/2.0/cms/denial-reasons/?is_active=true`,
    })
      .then((res) => {
        dispatch({ type: Constants.GET_DENIAL_REASON_SUCCESS, payload: res.data['denial-reasons'] });
        resolve(res.data['denial-reasons']);
      })
      .catch((error) => {
        dispatch({ type: Constants.GET_DENIAL_REASON_FAILED, payload: error });
        reject(error);
      });
  });

  export const deleteReceipt = ($http, ENV, transactionId, receiptId) => (dispatch) =>
    new Promise((resolve, reject) => {
      dispatch({ type: Constants.DELETE_RECEIPT_REQUEST });
  
      $http({
        method: 'DELETE',
        url: ENV.apiEndpoint + `/2.0/transactions/${transactionId}/receipts/${receiptId}/`,
      })
        .then((res) => {
          dispatch({ type: Constants.DELETE_RECEIPT_SUCCESS, payload: res.data.receipt });
          resolve(res.data.receipt);
        })
        .catch((error) => {
          dispatch({ type: Constants.DELETE_RECEIPT_FAILED, payload: error });
          reject(error);
        });
    });

export const clearTransaction = () => (dispatch) => dispatch({ type: Constants.CLEAR_TRANSACTION });
